import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Typography } from '@mui/material'

import { ThemeButton } from '../../../ui'

const formatList = (items) => {
  if (!items || items.length === 0) return ''
  if (items.length === 1) return items[0]
  return `${items.slice(0, -1).join(', ')} y ${items[items.length - 1]}`
}

export const AddTarifaDialog = ({ close, comunidades, onAccept }) => {
  const { formatMessage } = useIntl()
  const zonasDisponibles = formatList(comunidades)
  const isEmpty = !zonasDisponibles

  return (
    <Box p={4}>
      <Box mb={4}>
        <Typography variant="h4" color="primary" align="center">
          {formatMessage({
            id: 'pages.application.detail.dialogs.addTarifa.title',
            defaultMessage: 'Añadir tarifa',
          })}
        </Typography>
      </Box>

      <Typography variant="body1" color="textSecondary" align="left" paragraph>
        {isEmpty ? (
          <>
            {formatMessage({
              id: 'pages.application.detail.dialogs.addTarifa.noZonas',
              defaultMessage: 'Actualmente no puedes crear tarifas en ninguna zona.',
            })}{' '}
            {formatMessage({
              id: 'pages.application.detail.dialogs.addTarifa.description-withoutZones',
              defaultMessage:
                'Si quieres crear tarifas en otras zonas debes adherirte a alguna OP - Campaña de la zona deseada.',
            })}
          </>
        ) : (
          formatMessage(
            {
              id: 'pages.application.detail.dialogs.addTarifa.description-withZones',
              defaultMessage:
                'Actualmente puedes crear tarifas en {zonas}. Si quieres crear tarifas en otras zonas debes adherirte a alguna OP - Campaña de la zona deseada.',
            },
            { zonas: zonasDisponibles }
          )
        )}
      </Typography>
      <Box display="flex" justifyContent="center">
        <Box mr={6}>
          <ThemeButton color="default" labelM="lg" onClick={close}>
            {formatMessage({ id: 'global.cancel', defaultMessage: 'Cancelar' })}
          </ThemeButton>
        </Box>
        <ThemeButton
          labelM="lg"
          color="primary"
          onClick={() => {
            if (isEmpty) {
              close()
            } else {
              onAccept()
              close()
            }
          }}
        >
          {formatMessage({ id: 'global.accept', defaultMessage: 'Aceptar' })}
        </ThemeButton>
      </Box>
    </Box>
  )
}
